import React, { useState, useEffect, useReducer } from 'react';
import { Container, Message, Image, Menu, MenuItem } from 'semantic-ui-react';
import auth from './../Login/auth';
import ReactDataGrid from 'react-data-grid';
import {Toolbar, Data} from "react-data-grid-addons";
import { CSVLink, CSVDownload } from "react-csv";
import logo from '../../img/Logo Horizontal Blanco transparente.png';

//Propiedades de las columnas
const defaultColumnProperties = {
    filterable: true
  };

  const NumberFormatter = ({ value }) => {
    return <p style={{textAlign:"right"}}>$ {value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>;
  };
  
  //Columnas
  const columns = [
    {
      key: "nro_comp",
      name: "Nro. Comp.",
      width: 160
    },
    {
      key: "cod",
      name: "Pto. Vta.",
      width: 60
    },
    {
      key: "cotizacion",
      name: "Cotiz.",
      width: 60
    },
    {
      key: "fecha",
      name: "Fecha",
      width: 120
    },
    {
      key: "vence",
      name: "Vence",
      width: 120
    },
    {
      key: "debe",
      name: "Debe",
      width: 110,
      formatter: NumberFormatter
    },
    {
      key: "haber",
      name: "Haber",
      width: 110,
      formatter: NumberFormatter
    },
    {
      key: "saldo_cbte",
      name: "Saldo",
      width: 110,
      formatter: NumberFormatter
    }
  ].map(c => ({ ...c, ...defaultColumnProperties })); 

const handleFilterChange = filter => filters => {
  const newFilters = { ...filters };
  if (filter.filterTerm) {
    newFilters[filter.column.key] = filter;
  } else {
    delete newFilters[filter.column.key];
  }
  return newFilters;
};

function agregarTotalesPorGrupo(groupedRows){
  var saldo = 0;

  groupedRows.forEach(row => {
    saldo += row['saldo_cbte'];
  })

  //Agrego subtotales
  groupedRows.push({ 
    nro_comp: 'TOTAL',
    fecha: '',
    vence: '',
    debe: '',
    haber: '',
    saldo_cbte: saldo.toFixed(2)  
  });

  return groupedRows;

}

function getRows(rows, filters) {
  return selectors.getRows({ rows, filters });
} 

const selectors = Data.Selectors;

export const SaldoIndividual = props => {
    const [dataSaldo, setDataSaldo] = useState([]);
    const [filters, setFilters] = useState({});
      
    const rows = dataSaldo;
    const rowsTotal = agregarTotalesPorGrupo(rows);
    const filteredRows = getRows(rowsTotal, filters);  
    
    console.table(filteredRows);
    
    useEffect(() => {
      let mounted = true;
      getData()
        .then(items => {
          if(mounted) {
            setDataSaldo(items)
          }
        })
      return () => mounted = false;
    }, [])
  
    async function getData(){
      var cod_cli = auth.usuario.user[0]['cod_cli'];
      //var url = `http://192.168.87.41:8000/ctacte/${auth.db}/${cod_cli.trim()}?desde=${fechaDesde}&hasta=${fechaHasta}`; 
      var url = `http://webservices.crucianelli.com:8000//saldoIndividual/${cod_cli}`; 
      console.log(url);
      //query con fetch api asincronica
      let response = await fetch(url, {
        'mode': 'cors',
        'headers': {
            'Access-Control-Allow-Origin': '*',
        }
      });
      
      let data = await response.json();
      
      if (data.length !== 0) {
        return data;            
      }
    }

    return (    
        <div style={{width: '90%'}}>
            <Menu inverted color='red'>
                <MenuItem><h3>Saldo Individual</h3></MenuItem>          
                <MenuItem><h5>{auth.nombre}</h5></MenuItem>      
                <MenuItem position="right"><Image src={logo} size='small'></Image></MenuItem>    
            </Menu>
              <ReactDataGrid
                  columns={columns}
                  rowGetter={i => filteredRows[i]}
                  rowsCount={filteredRows.length}
                  minHeight={500}
                  enableCellAutoFocus={false}
                  toolbar={<Toolbar enableFilter={true} filterRowsButtonText = 'Filtrar' />}
                  onAddFilter={filter => setFilters(handleFilterChange(filter))}
                  onClearFilters={() => setFilters({})}
              />
              <Message warning>
                <Message.Header>Punto de venta 0020 correspondiente a facturas en dolares expresadas en pesos. 
                    Para estas facturas se tomará la cotización del dólar del efectivo pago.</Message.Header>
              </Message>
              <CSVLink data={dataSaldo} filename={"saldo_" + new Date(Date.now()).toLocaleString().split(',')[0] + ".csv"}>Exportar a Excel.</CSVLink>
        </div>)
}    